export const findBanksWithSomeStatuses = (banks = [], statusList = []) =>
  banks.filter(
    bank =>
      statusList.includes(bank.tinkPsd2Status) ||
      statusList.includes(bank.tinkStatus) ||
      statusList.includes(bank.psd2Status) ||
      statusList.includes(bank.status)
  );

export const getInfoToRenderAdvice = (foundBanks = []) => {
  let showAdvice = false,
    firstFoundBank = {},
    existSeveralBanks = false;

  if (foundBanks.length === 0) return [showAdvice, firstFoundBank, existSeveralBanks];
  if (foundBanks.length > 1) existSeveralBanks = true;
  showAdvice = true;
  firstFoundBank = foundBanks[0];

  return [showAdvice, firstFoundBank, existSeveralBanks];
};
